import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
// import Typography from '@mui/material/Typography';
// eslint-disable-next-line import/no-unresolved
import { TemporaryDrawer } from 'components/drawer/navDrawer';
// import Menu from '@mui/material/Menu';
import Container from '@mui/material/Container';
// import Button from '@mui/material/Button';
import { useLocation } from 'react-router-dom';
// import DehazeIcon from '@mui/icons-material/Dehaze';

// import MenuItem from '@mui/material/MenuItem';
// eslint-disable-next-line import/no-unresolved
import { useDevice } from 'hooks/useResponsive';
import { Grid, InputAdornment, Link, Popover, Stack, TextField, Typography } from '@mui/material';
// import HomeIcon from '@mui/icons-material/Home';
// import DriveEtaIcon from '@mui/icons-material/DriveEta';
// import SellIcon from '@mui/icons-material/Sell';
// import AirportShuttleRoundedIcon from '@mui/icons-material/AirportShuttleRounded';
import SearchIcon from '@mui/icons-material/Search';
// import CloseIcon from '@mui/icons-material/Close';
// import SearchSharpIcon from '@mui/icons-material/SearchSharp';
// import { Menu } from '@mui/icons-material';
import { useDispatch, useSelector } from 'react-redux';
import { getAllVehicles } from '../../server/api/vehicle';
import Logo from '../../components/logo/Logo';

const pages = [
  // { item: 'Home', link: '/home' },
  { item: 'Buy Used Car', link: '/allproducts' },
  { item: 'Sell Your Car', link: '/sell' },
  { item: 'Dream Car', link: '/dream' },
];

function Header() {
  const location = useLocation();
  const dispatch = useDispatch();
  const { isMobile } = useDevice();
  const inputRef = React.useRef(null);

  const [open, setOpen] = React.useState(false);

  const [search, setSearch] = React.useState('');
  const { allVehicleList } = useSelector((state) => ({
    allVehicleList: state.vehicle.allVehicleList?.vehicles,
  }));
  const [inputWidth, setInputWidth] = React.useState(300);

  React.useLayoutEffect(() => {
    if (inputRef.current) {
      setInputWidth(inputRef.current.offsetWidth);
    }
  }, [search]);
  // const [show, setShow] = React.useState(false);
  // const searchRef = React.useRef(null);

  // React.useEffect(() => {
  //   const handleClickOutside = (event) => {
  //     if (searchRef.current && !searchRef.current.contains(event.target)) {
  //       setShow(false); // Close search if click occurs outside the search box
  //     }
  //   };

  //   document.addEventListener('mousedown', handleClickOutside);

  //   return () => {
  //     document.removeEventListener('mousedown', handleClickOutside);
  //   };
  // }, []);
  // const handleCloseNavMenu = () => {
  //   setAnchorElNav(null);
  // };

  React.useEffect(() => {
    const data = {
      search,
    };
    dispatch(getAllVehicles(data));
  }, [dispatch, search]);

  const handleSearch = (value) => {
    setSearch(value);

    if (value.trim().length > 0) {
      setOpen(true);
      dispatch(getAllVehicles({ search: value }));
    } else {
      setOpen(false);
    }
  };
  // const [anchorElNav, setAnchorElNav] = React.useState(null);

  // const handleCloseNavMenu = () => {
  //   setAnchorElNav(null);
  // };
  // console.log(search);

  React.useEffect(() => {
    const handleClickOutside = (event) => {
      if (inputRef.current && !inputRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);
  return (
    <AppBar
      position="static"
      sx={{
        backgroundColor: '#121212',
        // backgroundColor: 'rgba(18, 18, 18, 0.7)',
        backdropFilter: 'blur(26.3px)',
        WebkitBackdropFilter: 'blur(26.3px)',
        boxShadow: 'none',
        p: { xs: 0, sm: 2 },
        px: { xs: 0, sm: 7 },
        pb: { xs: 1 },
        pt: { xs: 2 },
      }}
    >
      <Container maxWidth={isMobile ? 'lg' : ''}>
        <Toolbar
          disableGutters
          sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '25px' }}
        >
          <Box
            display={'flex'}
            alignItems={'center'}
            justifyContent={'space-between'}
            width={isMobile ? '100%' : 'fit-content'}
          >
            <Logo />
            {(location?.pathname === '/home' || location?.pathname === '/allproducts') && isMobile && (
              <Link href={'/search'} style={{ textDecoration: 'none' }}>
                <Grid>
                  <TextField
                    size="small"
                    placeholder="Search Your fav Car"
                    type="text"
                    className="custom-field-Header"
                    sx={{
                      width: '100%',
                      '& .MuiOutlinedInput-root': {
                        borderRadius: '16px',
                        '& fieldset': {
                          borderRadius: '16px',
                          borderColor: 'transparent', // remove border
                        },
                        '&:hover fieldset': {
                          borderColor: 'transparent', // no border on hover
                        },
                        '&.Mui-focused fieldset': {
                          borderColor: 'transparent', // no border on focus
                        },
                        '& input::placeholder': {
                          color: '#FFFFFF99',
                          opacity: 1,
                        },
                      },
                    }}
                    InputProps={{
                      autoComplete: 'off',
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon fontSize="small" sx={{ color: '#FFA800', transform: 'rotate(90deg)' }} />
                        </InputAdornment>
                      ),
                    }}
                  />
                  {/* <img
                src={`assets/images/Header/search.png`}
                alt=""
                style={{ position: 'absolute', top: 105, right: 30 }}
              /> */}
                </Grid>
              </Link>
            )}
            {isMobile && <TemporaryDrawer />}
          </Box>

          {/* <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: { xs: 'block', md: 'none' },
              }}
            >
              {pages?.map((page, key) => (
                <MenuItem key={key} onClick={handleCloseNavMenu}>
                  <Link to={page?.link} style={{ textDecoration: 'none', textAlign: 'center' }}>
                    <Typography textAlign="center" sx={{ color: 'black' }}>
                      {page?.item}
                    </Typography>
                  </Link>
                </MenuItem>
              ))}
            </Menu>
          </Box> */}

          {!isMobile && (
            <Box display={'flex'} flexDirection={'column'} sx={{ backgroundColor: '', width: '50%' }}>
              {/* {show ? (
                <CloseIcon
                  onClick={() => setShow(false)}
                  sx={{ cursor: 'pointer', transform: 'rotate(90deg)', color: '#FFA800' }}
                />
              ) : (
                <SearchIcon
                  onClick={() => setShow(true)}
                  sx={{ cursor: 'pointer', transform: 'rotate(90deg)', color: '#FFA800' }}
                />
              )} */}
              {/* {show && ( */}
              {/* <Box ref={searchRef} display={'flex'} flexDirection={'column'}>
                <TextField
                  // className="search-bar-web"
                  type="text"
                  value={search}
                  placeholder="Search Your fav Car"
                  onChange={(e) => handleSearch(e.target.value)}
                  InputProps={{
                    // autoComplete: 'off',
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon fontSize="small" sx={{ color: '#FFA800', transform: 'rotate(90deg)' }} />
                      </InputAdornment>
                    ),
                  }}
                  sx={{ border: '0px solid gray', borderRadius: '16px', width: '100%' }}
                />
                {search && search?.length >= 1 && allVehicleList?.length !== 0 && (
                  <Stack className="search-details">
                    {allVehicleList?.map((item, key) => (
                      <Link
                        href={`/product-single/${item?._id}`}
                        key={key}
                        sx={{ textDecoration: 'none', color: 'white' }}
                      >
                        <Box display={'flex'} p={1}>
                          <img
                            src={item?.images[0]?.url}
                            alt=""
                            height={25}
                            width={50}
                            style={{ objectFit: 'contain' }}
                          />
                          &nbsp;
                          <Typography>{item?.name}</Typography>
                        </Box>
                      </Link>
                    ))}
                  </Stack>
                )}
                {allVehicleList?.length === 0 && <Typography className="search-details">{'No Vehicle'}</Typography>}
              </Box> */}
              <>
                <TextField
                  inputRef={inputRef}
                  size="small"
                  autoFocus
                  placeholder="Search Your fav Car"
                  type="text"
                  value={search}
                  onChange={(e) => handleSearch(e.target.value)}
                  className="custom-field-Header"
                  sx={{
                    width: '100%',
                    '& .MuiOutlinedInput-root': {
                      borderRadius: '16px',
                      '& fieldset': {
                        border: 'none',
                      },
                      '&:hover fieldset': {
                        border: 'none',
                      },
                      '&.Mui-focused fieldset': {
                        border: 'none',
                      },
                      '& input::placeholder': {
                        color: '#FFFFFF99',
                        opacity: 1,
                      },
                      '& input': {
                        color: '#FFFFFFDE',
                      },
                    },
                  }}
                  InputProps={{
                    autoComplete: 'off',
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon fontSize="small" sx={{ color: '#FFA800', transform: 'rotate(90deg)' }} />
                      </InputAdornment>
                    ),
                  }}
                />
                <Popover
                  open={open && search.length > 0}
                  anchorEl={inputRef.current}
                  onClose={() => setOpen(false)}
                  disableAutoFocus // prevent stealing focus
                  disableEnforceFocus // prevent React from trying to "focus trap"
                  disableRestoreFocus
                  anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                  transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                  PaperProps={{
                    sx: {
                      backgroundColor: '#1A1A1A',
                      color: 'white',
                      width: `${inputWidth}px`,
                      maxHeight: 300,
                      overflowY: 'auto',
                      borderRadius: 2,
                      mt: 1,
                      boxShadow: 'unset',
                      zIndex: 1201,
                      '&::-webkit-scrollbar': {
                        width: '4px',
                      },
                      '&::-webkit-scrollbar-track': {
                        backgroundColor: 'transparent',
                      },
                      '&::-webkit-scrollbar-thumb': {
                        backgroundColor: '#555',
                        borderRadius: '4px',
                      },
                      '&::-webkit-scrollbar-button': {
                        display: 'none', // ✅ hides those up/down arrows
                      },
                      scrollbarWidth: 'thin', // Firefox
                      scrollbarColor: '#555 transparent',
                    },
                  }}
                >
                  {search?.length > 0 && allVehicleList?.length > 0 ? (
                    <Stack className="search-details">
                      {allVehicleList.map((item, key) => (
                        <Link
                          href={`/product-single/${item?._id}`}
                          key={key}
                          style={{ textDecoration: 'none', color: 'white' }}
                        >
                          <Box display={'flex'} alignItems="center" p={1}>
                            <img
                              src={item?.images[0]?.url}
                              alt=""
                              height={25}
                              width={50}
                              style={{ objectFit: 'contain' }}
                            />
                            &nbsp;
                            <Typography>{item?.name}</Typography>
                          </Box>
                        </Link>
                      ))}
                    </Stack>
                  ) : (
                    <Typography className="search-details" sx={{ p: 1 }}>
                      No Vehicle
                    </Typography>
                  )}
                </Popover>
              </>

              {/* )} */}
            </Box>
          )}

          <Box
            width={'100%'}
            sx={{
              display: { xs: 'none', md: 'flex' },
              justifyContent: 'end',
              width: isMobile ? '100%' : 'fit-content',
            }}
          >
            {pages?.map((page, key) => (
              <Link
                key={key}
                // component={Link}
                href={page?.link}
                // onClick={handleCloseNavMenu}
                sx={{ my: 2, color: '#E3E3E3', display: 'flex', alignItems: 'center', mx: 3, textDecoration: 'none' }}
              >
                {/* {page?.item === 'Home' ? (
                  <HomeIcon fontSize="small" className="head-icon-color" />
                ) : page?.item === 'Buy' ? (
                  <AirportShuttleRoundedIcon fontSize="small" className="head-icon-color" />
                ) : page?.item === 'Sell' ? (
                  <SellIcon fontSize="small" className="head-icon-color" />
                ) : (
                  <DriveEtaIcon fontSize="small" className="head-icon-color" />
                )} */}
                <Typography sx={{ padding: '3px 0px 0px 4px', color: '#FFFFFFDE', fontSize: '16px' }} fontWeight={600}>
                  {page?.item}
                </Typography>
              </Link>
            ))}
          </Box>
        </Toolbar>
        {/* {(location?.pathname === '/home' || location?.pathname === '/allproducts') && isMobile && (
          <Link href={'/search'} style={{ textDecoration: 'none' }}>
            <Grid mt={2}>
              <TextField
                placeholder="Search Your fav! 🚗"
                type="text"
                className="custom-field-sell"
                sx={{ border: '0px solid gray', borderRadius: '10px', width: '100%' }}
                InputProps={{ autoComplete: 'off' }}
              />
              <img
                src={`assets/images/Header/search.png`}
                alt=""
                style={{ position: 'absolute', top: 105, right: 30 }}
              />
            </Grid>
          </Link>
        )} */}
      </Container>
    </AppBar>
  );
}

export default Header;
